export class Location {
    constructor({
        id = null,
        code = ``,
        locName = ``,
        locType = ``,
        active = ``,
        timezone = ``,
        enterprise = ``,
        site = ``,
        area = ``,
        workCenter = ``,
        locationParent = null
    } = {}) {
        this.id = id;
        this.code = code;
        this.locName = locName;
        this.locType = locType;
        this.active = active;
        this.timezone = timezone;
        this.enterprise = enterprise;
        this.site = site;
        this.area = area;
        this.workCenter = workCenter;
        this.locationParent = locationParent;
    }
}
export function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'lbl.basic.id',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'code',
            label: 'lbl.basic.code',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'locName',
            label: 'lbl.basic.name',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'locType',
            label: 'lbl.basic.type',
            sortable: true,
            form: {
                type: 'select',
                options: [
                    { value: null, text: '' },
                    { value: 'E', text: '集团' },
                    { value: 'S', text: '公司' },
                    { value: 'A', text: '车间' },
                    { value: 'W', text: '工段' }
                  ]
            }         
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new Location()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.locNameFilter',
    'filter.codeFilter',
    'filter.locTypeFilter',
    'filter.activeFilter',
    'filter.statusFilter',
    'filter.childOfFilter'
];

export const filter = {
    'locNameFilter': "",
    'codeFilter': "",
    'locTypeFilter': "",
    'activeFilter': "",
    'statusFilter': "",
    'childOfFilter': ""
};